import { moment } from 'ngx-bootstrap/chronos/test/chain';

export const getFieldInputFilter = (type, key, index, formKey) => {
  switch (type) {
    case 'text':
      return (
        `<div class="e-value" data-key="` +
        key +
        `" id="${formKey}-group-input-` +
        key +
        `-` +
        index +
        `-eq">
                  <input type="radio" name="input-` +
        key +
        `-` +
        index +
        `" class="input-value-condition"
                        onchange="addInput('` +
        key +
        `', ` +
        index +
        `,'eq','` +
        type +
        `', '${formKey}')">
                  <span class="pl-5 pr-2">Bằng</span>
              </div>
              <div class="e-value" data-key="` +
        key +
        `" id="${formKey}-group-input-` +
        key +
        `-` +
        index +
        `-neq">
                  <input type="radio" name="input-` +
        key +
        `-` +
        index +
        `" class="input-value-condition"
                        onchange="addInput('` +
        key +
        `', ` +
        index +
        `,'neq','` +
        type +
        `', '${formKey}')">
                  <span class="pl-5 pr-2">Không Bằng</span>
              </div>
              <div class="e-value" data-key="` +
        key +
        `" id="${formKey}-group-input-` +
        key +
        `-` +
        index +
        `-in">
                  <input type="radio" name="input-` +
        key +
        `-` +
        index +
        `" class="input-value-condition"
                        onchange="addInput('` +
        key +
        `', ` +
        index +
        `,'in','` +
        type +
        `', '${formKey}')">
                  <span class="pl-5 pr-2">Có chứa</span>
              </div>
              <div class="e-value" data-key="` +
        key +
        `" id="${formKey}-group-input-` +
        key +
        `-` +
        index +
        `-nin">
                  <input type="radio" name="input-` +
        key +
        `-` +
        index +
        `" class="input-value-condition"
                        onchange="addInput('` +
        key +
        `', ` +
        index +
        `,'nin','` +
        type +
        `', '${formKey}')">
                  <span class="pl-5 pr-2">Không chứa</span>
              </div>`
      );
    case 'select':
      return (
        `<div class="e-value" data-key="` +
        key +
        `" id="${formKey}-group-input-` +
        key +
        `-` +
        index +
        `-eq">
                  <input type="radio" name="input-` +
        key +
        `-` +
        index +
        `" class="input-value-condition"
                        onchange="addInput('` +
        key +
        `', ` +
        index +
        `,'eq','` +
        type +
        `', '${formKey}')">
                  <span class="pl-5 pr-2">Bằng</span>
              </div>
              <div class="e-value" data-key="` +
        key +
        `" id="${formKey}-group-input-` +
        key +
        `-` +
        index +
        `-neq">
                  <input type="radio" name="input-` +
        key +
        `-` +
        index +
        `" class="input-value-condition"
                        onchange="addInput('` +
        key +
        `', ` +
        index +
        `,'neq','` +
        type +
        `', '${formKey}')">
                  <span class="pl-5 pr-2">Không Bằng</span>
              </div>`
      );
    case 'date':
      return (
        `<div class="e-value" data-key="` +
        key +
        `" id="${formKey}-group-input-` +
        key +
        `-` +
        index +
        `-eq">
                  <input type="radio" name="input-` +
        key +
        `-` +
        index +
        `" class="input-value-condition"
                        onchange="addInput('` +
        key +
        `', ` +
        index +
        `,'eq','` +
        type +
        `', '${formKey}')">
                  <span class="pl-5 pr-2">Trong ngày</span>
              </div>
              <div class="e-value" data-key="` +
        key +
        `" id="${formKey}-group-input-` +
        key +
        `-` +
        index +
        `-gt">
                  <input type="radio" name="input-` +
        key +
        `-` +
        index +
        `" class="input-value-condition"
                        onchange="addInput('` +
        key +
        `', ` +
        index +
        `,'gt','` +
        type +
        `', '${formKey}')">
                  <span class="pl-5 pr-2">Sau ngày</span>
              </div>
              <div class="e-value" data-key="` +
        key +
        `" id="${formKey}-group-input-` +
        key +
        `-` +
        index +
        `-lt">
                  <input type="radio" name="input-` +
        key +
        `-` +
        index +
        `" class="input-value-condition"
                        onchange="addInput('` +
        key +
        `', ` +
        index +
        `,'lt','` +
        type +
        `', '${formKey}')">
                  <span class="pl-5 pr-2">Trước ngày</span>
              </div>`
      );
    case 'number':
      return (
        `<div class="e-value" data-key="` +
        key +
        `" id="${formKey}-group-input-` +
        key +
        `-` +
        index +
        `-eq">
                  <input type="radio" name="input-` +
        key +
        `-` +
        index +
        `" class="input-value-condition"
                        onchange="addInput('` +
        key +
        `', ` +
        index +
        `,'eq','` +
        type +
        `', '${formKey}')">
                  <span class="pl-5 pr-2">Bằng</span>
              </div>
              <div class="e-value" data-key="` +
        key +
        `" id="${formKey}-group-input-` +
        key +
        `-` +
        index +
        `-gte">
                  <input type="radio" name="input-` +
        key +
        `-` +
        index +
        `" class="input-value-condition"
                        onchange="addInput('` +
        key +
        `', ` +
        index +
        `,'gte','` +
        type +
        `', '${formKey}')">
                  <span class="pl-5 pr-2">Lớn hơn</span>
              </div>
              <div class="e-value" data-key="` +
        key +
        `" id="${formKey}-group-input-` +
        key +
        `-` +
        index +
        `-lte">
                  <input type="radio" name="input-` +
        key +
        `-` +
        index +
        `" class="input-value-condition"
                        onchange="addInput('` +
        key +
        `', ` +
        index +
        `,'lte','` +
        type +
        `', '${formKey}')">
                  <span class="pl-5 pr-2">Nhỏ hơn</span>
              </div>`
      );
    default:
      return '';
  }
};

export const addInputValue = (type, key, id, label, formKey) => {
  const box = $(`#${formKey}-box-${key}-${id}`);
  let html = '';
  switch (type) {
    case 'text':
      box.find('.input-text').remove();
      return (
        `<input type="text" class="form-control input-text" style="height: 25px; margin-left: 10px;width: 150px;z-index=0;"
                  id="value-` +
        key +
        `-` +
        id +
        `-` +
        label +
        `"
                  data-key="` +
        key +
        `"
                  data-index="` +
        id +
        `" data-label="` +
        label +
        `">`
      );
    case 'select':
      box.find('.select2').remove();
      box.find('.group-select').remove();
      html =
        `<div class="group-select">
                  <select type="text" class="form-control input-select" style="height: 25px; margin-left: 10px;width: 150px;z-index=0;"
                          id="value-` +
        key +
        `-` +
        id +
        `-` +
        label +
        `"
                          data-key="` +
        key +
        `"
                          data-index="` +
        id +
        `"
                          data-label="` +
        label +
        `" >`;
      html += '<option value=""></option>';
      const data = $(`#${formKey}-box-${key}`).data('x');
      data.forEach(e => {
        html += '<option value="' + e.id + '">' + e.text + '</option>';
      });
      html += '</select></div>';
      return html;
    case 'date':
      box.find('.input-date').remove();
      box.find('.group-date').remove();
      html =
        `<div class="input-group group-date">
                   <input type="text" data-plugin="datepicker" class="form-control input-date" style="height: 25px; margin-left: 10px;width: 150px;z-index=0;"
                          id="value-` +
        key +
        `-` +
        id +
        `-` +
        label +
        `"
                          data-key="` +
        key +
        `"
                          data-index="` +
        id +
        `"
                          data-label="` +
        label +
        `">`;
      html += `<span class="input-group-addon" style="height:25px">
                   <i class="icon wb-calendar" aria-hidden="true"></i>
               </span></div>`;
      return html;
    case 'number':
      box.find('.input-number').remove();
      return (
        `<input type="number" class="form-control input-number" style="height: 25px; margin-left: 10px;width: 150px;z-index=0;"
                      id="value-` +
        key +
        `-` +
        id +
        `-` +
        label +
        `"
                      data-key="` +
        key +
        `"
                      data-index="` +
        id +
        `"
                      data-label="` +
        label +
        `">`
      );
    default:
      return '';
  }
};

export const getDataFromInput = formKey => {
  let data = {},
    active_fields = [];
  [data, active_fields] = getDataFromInputText(formKey, data, active_fields);
  [data, active_fields] = getDataFromInputNumber(formKey, data, active_fields);
  [data, active_fields] = getDataFromInputSelect(formKey, data, active_fields);
  [data, active_fields] = getDataFromInputDate(formKey, data, active_fields);
  return [data, active_fields];
};

const getDataFromInputText = (formKey, data: any = {}, active_fields: any = []) => {
  $(`#${formKey}-group-input-condition`)
    .find('.input-text')
    .each((index, elem) => {
      const key = $(elem).data('key');
      const label = $(elem).data('label');
      const val = $(elem).val();
      if (val) {
        active_fields.push(key);
        let tmp = {};
        switch (label) {
          case 'eq': {
            if (key == 'phone') {
              tmp = {
                bool: {
                  should: [{ term: { sub_phone: val } }, { match: { phone: val } }],
                },
              };
            } else {
              const eq = {};
              eq[key] = val;
              tmp = { match: eq };
            }
            break;
          }
          case 'neq': {
            const eq = {};
            eq[key] = val;
            tmp = {
              bool: {
                must_not: {
                  match: eq,
                },
              },
            };
            break;
          }
          case 'in': {
            const query_in = {};
            query_in[key] = val;

            tmp = {
              match_phrase: query_in,
            };
            break;
          }
          case 'nin': {
            const query_in = {};
            query_in[key] = val;
            tmp = {
              bool: {
                must_not: {
                  match_phrase: query_in,
                },
              },
            };
            break;
          }
          case 'gte': {
            const range = {};
            range[key] = {
              gte: val,
            };
            tmp = {
              range: range,
            };
            break;
          }
          case 'lte': {
            const range = {};
            range[key] = {
              lte: val,
            };
            tmp = {
              range: range,
            };
            break;
          }
          default:
            break;
        }

        if (!data[key]) {
          data[key] = [tmp];
        } else {
          data[key].push(tmp);
        }
      }
    });
  return [data, active_fields];
};
const getDataFromInputNumber = (formKey, data: any = {}, active_fields: any = []) => {
  $(`#${formKey}-group-input-condition`)
    .find('.input-number')
    .each((index, elem) => {
      const key = $(elem).data('key');
      const label = $(elem).data('label');
      const val = $(elem).val();
      if (val) {
        active_fields.push(key);
        let tmp = {};
        switch (label) {
          case 'eq': {
            const eq = {};
            eq[key] = val;
            tmp = { match: eq };
            break;
          }
          case 'gte': {
            const range = {};
            range[key] = {
              gte: val,
            };
            tmp = {
              range: range,
            };
            break;
          }
          case 'lte': {
            const range = {};
            range[key] = {
              lte: val,
            };
            tmp = {
              range: range,
            };
            break;
          }
          default:
            break;
        }

        if (!data[key]) {
          data[key] = [tmp];
        } else {
          data[key].push(tmp);
        }
      }
    });

  return [data, active_fields];
};
const getDataFromInputSelect = (formKey, data: any = {}, active_fields: any = []) => {
  $(`#${formKey}-group-input-condition`)
    .find('.input-select')
    .each((index, elem) => {
      const key = $(elem).data('key');
      const label = $(elem).data('label');
      const val = $(elem).val();
      if (val) {
        active_fields.push(key);
        let tmp = {};
        switch (label) {
          case 'eq': {
            const eq = {};
            if (key.indexOf('ex_ticket') > -1) {
              eq[key + '.keyword'] = val.toString().toLowerCase();
            } else {
              eq[key] = val.toString().toLowerCase();
            }
            tmp = { match_phrase: eq };
            break;
          }
          case 'neq': {
            const eq = {};
            eq[key] = val.toString().toLowerCase();
            tmp = {
              bool: {
                must_not: {
                  match_phrase: eq,
                },
              },
            };
            break;
          }
          default:
            break;
        }

        if (!data[key]) {
          data[key] = [tmp];
        } else {
          data[key].push(tmp);
        }
      }
    });

  return [data, active_fields];
};
const getDataFromInputDate = (formKey, data: any = {}, active_fields: any = []) => {
  $(`#${formKey}-group-input-condition`)
    .find('.input-date')
    .each((index, elem) => {
      const key = $(elem).data('key');
      const label = $(elem).data('label');
      const val = moment($(elem).val(), 'DD-MM-YYYY');
      console.log(val);
      const start_date = moment(moment($(elem).val(), 'DD-MM-YYYY')).format('YYYY-MM-DD') + 'T00:00:00.000Z';
      const end_date = moment(moment($(elem).val(), 'DD-MM-YYYY')).format('YYYY-MM-DD') + 'T23:59:59.999Z';
      if (val) {
        active_fields.push(key);
        let tmp = {};
        switch (label) {
          case 'eq': {
            const range = {};
            range[key] = {
              gte: start_date,
              lte: end_date,
            };
            tmp = {
              range: range,
            };
            break;
          }
          case 'gt': {
            const range = {};
            range[key] = {
              gt: end_date,
            };
            tmp = {
              range: range,
            };
            break;
          }
          case 'lt': {
            const range = {};
            range[key] = {
              lt: start_date,
            };
            tmp = {
              range: range,
            };
            break;
          }
          default:
            break;
        }

        if (!data[key]) {
          data[key] = [tmp];
        } else {
          data[key].push(tmp);
        }
      }
    });
  return [data, active_fields];
};
export const getForm = formKey => {
  const data = {};
  const el = $(`#${formKey}-group-input-condition`);
  el.find('.input-text').each((index, elem) => {
    const key = $(elem).data('key');
    const label = $(elem).data('label');
    const val = $(elem).val();
    if (!data[key]) {
      data[key] = [{ label: label, val: val }];
    } else {
      data[key].push({ label: label, val: val });
    }
  });

  el.find('.input-select').each((index, elem) => {
    const key = $(elem).data('key');
    const label = $(elem).data('label');
    const val = $(elem).val();
    if (!data[key]) {
      data[key] = [{ label: label, val: val }];
    } else {
      data[key].push({ label: label, val: val });
    }
  });

  el.find('.input-date').each((index, elem) => {
    const key = $(elem).data('key');
    const label = $(elem).data('label');
    console.log($(elem).val());
    const val = moment(moment($(elem).val(), 'DD-MM-YYYY')).format('YYYY-MM-DD HH:mm:ss');
    console.log(elem);
    if (!data[key]) {
      data[key] = [{ label: label, val: val }];
    } else {
      data[key].push({ label: label, val: val });
    }
  });
  return data;
};

export const MonthOptions = [
  { id: '01', text: 'Tháng 1' },
  { id: '02', text: 'Tháng 2' },
  { id: '03', text: 'Tháng 3' },
  { id: '04', text: 'Tháng 4' },
  { id: '05', text: 'Tháng 5' },
  { id: '06', text: 'Tháng 6' },
  { id: '07', text: 'Tháng 7' },
  { id: '08', text: 'Tháng 8' },
  { id: '09', text: 'Tháng 9' },
  { id: '10', text: 'Tháng 10' },
  { id: '11', text: 'Tháng 11' },
  { id: '12', text: 'Tháng 12' },
];



// WEBPACK FOOTER //
// ./src/app/components/advanced-filter/advanced-filter.const.ts